import styled from "styled-components";
import tw from "twin.macro";

export const StyledLogo = styled.img.attrs({
    className: 'logo'
})`
    ${tw`w-36`}
`;